import { computed} from 'vue'
import { useLandingPage } from '@/stores/landingPage'

const EU_GDPR_COUNTRY_CODES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU',
    'IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
    'IS','LI','NO']
  
const UK_GDPR_COUNTRY_CODES = ['GB']

const allLinks = [
    { name: 'Blog', href: 'https://stan.store/blog' },
    {
        name: 'Referral Program',
        href: 'https://help.stan.store/article/89-referral-program-overview',
    },
    { name: 'Ambassador Program', href: 'https://www.stan.store/partnerships' },
    { name: 'Jobs', href: 'https://jobs.stan.store/' },
    { name: 'Help', href: 'https://help.stan.store/' },
    { name: 'Privacy Policy', href: 'https://assets.stanwith.me/legal/privacy-policy.pdf' },
    { name: 'GDPR Compliance Certificate', href: 'https://assets.stanwith.me/legal/EU_GDPR.pdf', countries: EU_GDPR_COUNTRY_CODES  },
    { name: 'GDPR Compliance Certificate', href: 'https://assets.stanwith.me/legal/UK_GDPR.pdf', countries: UK_GDPR_COUNTRY_CODES },
    { name: 'Terms and Conditions', href: 'https://assets.stanwith.me/legal/terms-of-service.pdf' },
]



export default (props, socials) => {
    const landingPage = useLandingPage()
    const socialsList = computed(() => {
        return socials.slice().reverse()
    })
    const country = computed(() => {
        return landingPage.country
    })

    const links = computed(() => {
        const filteredLinks = allLinks.filter(link => {
            if (link.countries) {
                return link.countries.includes(country.value)
            }
            return true
        })

        return filteredLinks
    })

    return {
        baseId: `${props.id}`,
        addonId: `${props.id}-add-on`,
        socialsList,
        links,
        country,
        landingPage,
    }
}
